// Copyright (c) 2017+,COMUNICARE SOLUTIONS SA
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without modification,
// are NOT permitted.

import { Identifier, Reference } from "../models/sharedInterfaces";
import { IAccount } from "./account-helper";
import { FileLogger } from "./fileLogger";

/**
 *  Helper class to handle FHIR format
 */
export class FHIRHelper {
  public static get USUAL(): string {
    return "usual";
  }

  public static get SYSTEM_CAREMATE(): string {
    return "http://comunicare.io";
  }
  public static get SYSTEM_TELECOM_MAIL(): string {
    return "email";
  }
  public static get SYSTEM_TELECOM_PHONE(): string {
    return "phone";
  }
  public static get SYSTEM_CONTACT_INSURANCE(): string {
    return "ins";
  }
  public static get SYSTEM_ORGANIZATION(): string {
    return "organization";
  }
  // FHIR ressource types
  public static get RES_CAREPLAN(): string {
    return "CarePlan";
  }
  public static get RES_ACTIVITY(): string {
    return "Activity";
  }
  public static get RES_PATIENT(): string {
    return "Patient";
  }
  public static get RES_APPOINTMENT(): string {
    return "Appointment";
  }
  public static get RES_PRACTITIONER(): string {
    return "Practitioner";
  }
  public static get RES_ORGANIZATION(): string {
    return "Organization";
  }
  public static get RES_OBSERVATION(): string {
    return "Observation";
  }
  public static get RES_QUESTIONNAIRE(): string {
    return "Questionnaire";
  }
  public static get RES_QUESTIONNAIRERESPONSE(): string {
    return "QuestionnaireResponse";
  }

  // Questionnaire Reponse status
  public static get QRESPONSE_STATUS_COMPLETED(): string {
    return "completed";
  }
  public static get QRESPONSE_STATUS_INPROGRESS(): string {
    return "in-progress";
  }

  public static get GOAL_CATEGORY_CARDIO(): string {
    return "cardio-frequency";
  }

  /**
   * convert an IAccount to a Reference
   */
  public static account2Reference(account: IAccount): Reference {
    return {
      reference: account.caremateIdentifier,
      display: account.name + " " + account.firstname,
    };
  }

  /**
   * return Caremate Identifier from an IEntity
   */
  public static getCaremateIdentifier(entity: any): Identifier {
    try {
      if (entity.identifier) {
        for (const ident of entity.identifier) {
          if ((ident as Identifier).system === FHIRHelper.SYSTEM_CAREMATE || (ident as Identifier).system === "caremate")
            return ident as Identifier;
        }
      }
    } catch (e) {
      FileLogger.error("FHIRHelper", "getCaremateIdentifier", e);
    }
    return null;
  }

  /**
   * Return main identifier
   * @param entity
   */
  /*public static getMainIdentifier(entity: any): Identifier {
        try {
            for (let identifier of entity.identifier) {
                if ((identifier.system === FHIRHelper.SYSTEM_CAREMATE) || (identifier.system === "caremate")) {
                    return identifier;
                }
            }
        }
        catch (err) { }
        return null;
    }*/
}
